export default input => /^data:/.test(input);



// WEBPACK FOOTER //
// ./app/services/is-data-url.js